module.exports = __webpack_public_path__ + "static/media/r6.ae3886a6.jpg";